
























import { Component, Vue, Emit, Prop } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { updateInfo } from '@/apis/myInfo/myInfo.ts'
import i18n from '@/lang';
@Component({})
export default class MajorShowFirst extends Vue {
  // @Inject:['say']
  @Prop() parentMsg!: any
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }

  @Emit('childCLick')
  //点击新增课程  调用父级方法
  childCLick() {}
  //删除按钮
  remove(index: number) {
    this.parentMsg.splice(index, 1)
  }

  //保存
  public keep(back = true) {
    let arr: any = []
    for (let i = 0; i < this.parentMsg.length; i++) {
      arr[i] = this.parentMsg[i].content
    }

    // let allArr = this.parentMsg.concat(this.userInfo.majors)
    // console.log(allArr)
    // let arr: any = []
    // for (let i = 0; i < allArr.length; i++) {
    //   // if(allArr[i])
    //   arr[i].type = allArr[i].type
    //   arr[i].id = allArr[i].id
    //   arr[i].title = allArr[i].title
    // }
    updateInfo({
      username: this.userInfo.username,
      school: this.userInfo.school,
      department: this.userInfo.department,
      teachcourse: this.userInfo.teachcourse,
      stno: this.userInfo.stno,
      majors: arr,
      classno: this.userInfo.additionInfo!.classno,
      enrolltime: this.userInfo.additionInfo!.enrolltime,
      grade: this.userInfo.additionInfo!.grade,
    })
      .then((res) => {
        this.$store.dispatch('setUserInfo').then(() => {
          if (back) {
            this.$router.back()
          }
        })
      })
      .catch((e) => {})
  }

  created() {
    this.showData()
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.专业') as string,
      showTitle: true,
    })
  }
  //处理数据
  showData() {
    for (let i = 0; i < this.parentMsg.length; i++) {
      if (this.parentMsg[i].type == '3') {
        this.parentMsg[i].bigTitle = i18n.t('ktpMy.高等教育')
      } else if (this.parentMsg[i].type == '1') {
        this.parentMsg[i].bigTitle = i18n.t('ktpMy.高职教育')
      } else {
        this.parentMsg[i].bigTitle = i18n.t('ktpMy.中职教育')
      }
      if (this.parentMsg[i].children) {
        this.parentMsg[i].mess = this.parentMsg[i].bigTitle + '/' + this.parentMsg[i].title + '/' + this.parentMsg[i].children.title
      } else {
        this.parentMsg[i].mess = this.parentMsg[i].title
      }
      this.parentMsg[i].content = {}
      this.parentMsg[i].content.type = this.parentMsg[i].type
      this.parentMsg[i].content.id = this.parentMsg[i].id
      if (this.parentMsg[i].children) {
      this.parentMsg[i].content.title = this.parentMsg[i].children.title
      }else{
        this.parentMsg[i].mess = this.parentMsg[i].title
      }
    }
  }
}
